import React, { useRef, useState, useEffect } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Api } from '../../../services/api';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { InputNumber } from 'primereact/inputnumber';
import { FaPlus, FaSave, FaTrash } from 'react-icons/fa';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { EsrDashboardTemp } from '../../../services/Executive/esr-dashboard';
import './ESRDashboard.css';

const EsrDashboard = () => {
    const [isLoading, setIsLoading] = useState(true);

    const [financials, setFinancials] = useState(EsrDashboardTemp.getFormName().Financials);
    const [Sales, setSales] = useState(EsrDashboardTemp.getFormName().Sales);
    const [Critical_Dates, setCritical_Dates] = useState(EsrDashboardTemp.getFormName().Critical_Dates);
    const [SI_Project, setSI_Project] = useState(EsrDashboardTemp.getFormName().SI_Project);
    const [SI_Personal, setSI_Personal] = useState(EsrDashboardTemp.getFormName().SI_Personal);
    const [issue_list_project, setissue_list_project] = useState(EsrDashboardTemp.getFormName().issue_list_project);
    const [issue_list_personal, setissue_list_personal] = useState(EsrDashboardTemp.getFormName().issue_list_personal);
    const [complate_task_project, setcomplate_task_project] = useState(EsrDashboardTemp.getFormName().complate_task_project);
    const [complate_task_personal, setcomplate_task_personal] = useState(EsrDashboardTemp.getFormName().complate_task_personal);
    const [quarter, setQuarter] = useState('Q1');



    // ----------------------------------------------------------------------------

    useEffect(() => {
        getTemplateDetails(quarter);

    }, [quarter]);



    const getTemplateDetails = (qu) => {
        formik.setFieldValue(`quarter`, qu);
        var url = Api.API_BASE_URL + 'esr/get-all';
        var data = {
            user_id: localStorage.getItem('user_id'),
            role_id: localStorage.getItem('role_id'),
            quarter: qu
        };

        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            ...Api.headers,
            'Authorization': token ? `Bearer ${token}` : ''
        };

        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.error === '') {

                    // if (response.Financials.length > 0) {
                    //     setFinancials(response.Financials);

                    //     formik.setFieldValue(`Financials`, response.Financials);

                    // } else {
                    //     setFinancials(EsrDashboardTemp.getFormName().Financials);
                    //     formik.setFieldValue(`Financials`, EsrDashboardTemp.getFormName().Financials);
                    // }

                    // if (response.Sales.length > 0) {
                    //     setSales(response.Sales);

                    //     formik.setFieldValue(`Sales`, response.Sales);

                    // } else {
                    //     setSales(EsrDashboardTemp.getFormName().Sales);
                    //     formik.setFieldValue(`Sales`, EsrDashboardTemp.getFormName().Sales);
                    // }

                    // if (response.Critical_Dates.length > 0) {
                    //     setCritical_Dates(response.Critical_Dates);

                    //     formik.setFieldValue(`Critical_Dates`, response.Critical_Dates);

                    // } else {
                    //     setCritical_Dates(EsrDashboardTemp.getFormName().Critical_Dates);
                    //     formik.setFieldValue(`Critical_Dates`, EsrDashboardTemp.getFormName().Critical_Dates);
                    // }

                    // if (response.SI_Project.length > 0) {
                    //     setSI_Project(response.SI_Project);

                    //     formik.setFieldValue(`SI_Project`, response.SI_Project);

                    // } else {
                    //     setSI_Project(EsrDashboardTemp.getFormName().SI_Project);
                    //     formik.setFieldValue(`SI_Project`, EsrDashboardTemp.getFormName().SI_Project);
                    // }

                    // if (response.SI_Personal.length > 0) {
                    //     setSI_Personal(response.SI_Personal);

                    //     formik.setFieldValue(`SI_Personal`, response.SI_Personal);

                    // } else {
                    //     setSI_Personal(EsrDashboardTemp.getFormName().SI_Personal);
                    //     formik.setFieldValue(`SI_Personal`, EsrDashboardTemp.getFormName().SI_Personal);
                    // }

                    // if (response.issue_list_project.length > 0) {
                    //     setissue_list_project(response.issue_list_project);

                    //     formik.setFieldValue(`issue_list_project`, response.issue_list_project);

                    // } else {
                    //     setissue_list_project(EsrDashboardTemp.getFormName().issue_list_project);
                    //     formik.setFieldValue(`issue_list_project`, EsrDashboardTemp.getFormName().issue_list_project);
                    // }

                    // if (response.issue_list_personal.length > 0) {
                    //     setissue_list_personal(response.issue_list_personal);

                    //     formik.setFieldValue(`issue_list_personal`, response.issue_list_personal);

                    // } else {
                    //     setissue_list_personal(EsrDashboardTemp.getFormName().issue_list_personal);
                    //     formik.setFieldValue(`issue_list_personal`, EsrDashboardTemp.getFormName().issue_list_personal);
                    // }

                    // if (response.complate_task_project.length > 0) {
                    //     setcomplate_task_project(response.complate_task_project);

                    //     formik.setFieldValue(`complate_task_project`, response.complate_task_project);

                    // } else {
                    //     setcomplate_task_project(EsrDashboardTemp.getFormName().complate_task_project);
                    //     formik.setFieldValue(`complate_task_project`, EsrDashboardTemp.getFormName().complate_task_project);
                    // }

                    // if (response.complate_task_personal.length > 0) {
                    //     setcomplate_task_personal(response.complate_task_personal);

                    //     formik.setFieldValue(`complate_task_personal`, response.complate_task_personal);

                    // } else {
                    //     setcomplate_task_personal(EsrDashboardTemp.getFormName().complate_task_personal);
                    //     formik.setFieldValue(`complate_task_personal`, EsrDashboardTemp.getFormName().complate_task_personal);
                    // }
                    console.log("response.Financials", response.Financials);

                    const financialsData = response.Financials.length > 0 ? response.Financials : EsrDashboardTemp.getFormName().Financials;
                    setFinancials(financialsData); // Add this line to update 

                    formik.setValues({
                        ...formik.values,
                        quarter: qu,
                        Financials: response.Financials.length > 0 ? response.Financials : EsrDashboardTemp.getFormName().Financials,
                        Sales: response.Sales.length > 0 ? response.Sales : EsrDashboardTemp.getFormName().Sales,
                        Critical_Dates: response.Critical_Dates.length > 0 ? response.Critical_Dates : EsrDashboardTemp.getFormName().Critical_Dates,
                        SI_Project: response.SI_Project.length > 0 ? response.SI_Project : EsrDashboardTemp.getFormName().SI_Project,
                        SI_Personal: response.SI_Personal.length > 0 ? response.SI_Personal : EsrDashboardTemp.getFormName().SI_Personal,
                        issue_list_project: response.issue_list_project.length > 0 ? response.issue_list_project : EsrDashboardTemp.getFormName().issue_list_project,
                        issue_list_personal: response.issue_list_personal.length > 0 ? response.issue_list_personal : EsrDashboardTemp.getFormName().issue_list_personal,
                        complate_task_project: response.complate_task_project.length > 0 ? response.complate_task_project : EsrDashboardTemp.getFormName().complate_task_project,
                        complate_task_personal: response.complate_task_personal.length > 0 ? response.complate_task_personal : EsrDashboardTemp.getFormName().complate_task_personal
                    });

                }
                else {
                    console.log(response.error);
                }

            })
            .catch((error) => {
                console.error("Error:", error);
            });

    }

    // ----------------------------------------------------------------------------
    const handleAddInputForFinancials = () => {
        // setFinancials([...financials, EsrDashboardTemp.getFormName().Financials[0]]);
        // formik.values.Financials.push(EsrDashboardTemp.getFormName().Financials[0]);

        const updated = [...formik.values.Financials, EsrDashboardTemp.getFormName().Financials[0]];
        formik.setFieldValue('Financials', updated);
    };

    const handleDeleteInputForFinancials = (index) => {
        // setFinancials([...financials, 2]);
        // var newArray = [...financials];
        // newArray.splice(index, 1);
        // formik.values.Financials.splice(index, 1);
        // setFinancials(newArray);

        const updated = [...formik.values.Financials];
        updated.splice(index, 1);
        formik.setFieldValue('Financials', updated);
    };

    const handleAddInputForSales = () => {
        setSales([...Sales, EsrDashboardTemp.getFormName().Sales[0]]);
        formik.values.Sales.push(EsrDashboardTemp.getFormName().Sales[0]);
    };

    const handleDeleteInputForSales = (index) => {
        setSales([...Sales, 2]);
        var newArray = [...Sales];
        newArray.splice(index, 1);
        formik.values.Sales.splice(index, 1);
        setSales(newArray);
    };

    const handleAddInputForCritical_Dates = () => {
        setCritical_Dates([...Critical_Dates, EsrDashboardTemp.getFormName().Critical_Dates[0]]);
        formik.values.Critical_Dates.push(EsrDashboardTemp.getFormName().Critical_Dates[0]);
    };

    const handleDeleteInputForCritical_Dates = (index) => {
        setCritical_Dates([...Critical_Dates, 2]);
        var newArray = [...Critical_Dates];
        newArray.splice(index, 1);
        formik.values.Critical_Dates.splice(index, 1);
        setCritical_Dates(newArray);
    };

    const handleAddInputForSI_Project = () => {
        setSI_Project([...SI_Project, EsrDashboardTemp.getFormName().SI_Project[0]]);
        formik.values.SI_Project.push(EsrDashboardTemp.getFormName().SI_Project[0]);
    };

    const handleDeleteInputForSI_Project = (index) => {
        setSI_Project([...SI_Project, 2]);
        var newArray = [...SI_Project];
        newArray.splice(index, 1);
        formik.values.SI_Project.splice(index, 1);
        setSI_Project(newArray);
    };

    const handleAddInputForSI_Personal = () => {
        setSI_Personal([...SI_Personal, EsrDashboardTemp.getFormName().SI_Personal[0]]);
        formik.values.SI_Personal.push(EsrDashboardTemp.getFormName().SI_Personal[0]);
    };

    const handleDeleteInputForSI_Personal = (index) => {
        setSI_Personal([...SI_Personal, 2]);
        var newArray = [...SI_Personal];
        newArray.splice(index, 1);
        formik.values.SI_Personal.splice(index, 1);
        setSI_Personal(newArray);
    };

    const handleAddInputForissue_list_project = () => {
        setissue_list_project([...issue_list_project, EsrDashboardTemp.getFormName().issue_list_project[0]]);
        formik.values.issue_list_project.push(EsrDashboardTemp.getFormName().issue_list_project[0]);
    };

    const handleDeleteInputForissue_list_project = (index) => {
        setissue_list_project([...issue_list_project, 2]);
        var newArray = [...issue_list_project];
        newArray.splice(index, 1);
        formik.values.issue_list_project.splice(index, 1);
        setissue_list_project(newArray);
    };

    const handleAddInputForissue_list_personal = () => {
        setissue_list_personal([...issue_list_personal, EsrDashboardTemp.getFormName().issue_list_personal[0]]);
        formik.values.issue_list_personal.push(EsrDashboardTemp.getFormName().issue_list_personal[0]);
    };

    const handleDeleteInputForissue_list_personal = (index) => {
        setissue_list_personal([...issue_list_personal, 2]);
        var newArray = [...issue_list_personal];
        newArray.splice(index, 1);
        formik.values.issue_list_personal.splice(index, 1);
        setissue_list_personal(newArray);
    };

    const handleAddInputForcomplate_task_project = () => {
        setcomplate_task_project([...complate_task_project, EsrDashboardTemp.getFormName().complate_task_project[0]]);
        formik.values.complate_task_project.push(EsrDashboardTemp.getFormName().complate_task_project[0]);
    };

    const handleDeleteInputForcomplate_task_project = (index) => {
        setcomplate_task_project([...complate_task_project, 2]);
        var newArray = [...complate_task_project];
        newArray.splice(index, 1);
        formik.values.complate_task_project.splice(index, 1);
        setcomplate_task_project(newArray);
    };

    const handleAddInputForcomplate_task_personal = () => {
        setcomplate_task_personal([...complate_task_personal, EsrDashboardTemp.getFormName().complate_task_personal[0]]);
        formik.values.complate_task_personal.push(EsrDashboardTemp.getFormName().complate_task_personal[0]);
    };

    const handleDeleteInputForcomplate_task_personal = (index) => {
        setcomplate_task_personal([...complate_task_personal, 2]);
        var newArray = [...complate_task_personal];
        newArray.splice(index, 1);
        formik.values.complate_task_personal.splice(index, 1);
        setcomplate_task_personal(newArray);
    };


    // ----------------------------------------------------------------------------

    const headerStyle = {
        background: "#f8f9fa", // light gray
        borderBottom: "2px solid #dee2e6",
        textAlign: "center",
        fontSize: "16px",
        fontWeight: "600",
        color: "#343a40"
    };

    const cellStyle = {
        border: "1px solid #dee2e6",
        padding: "6px 8px",
        fontSize: "14px",
        backgroundColor: "#ffffff",
    };

    const cellStyleW = {
        ...cellStyle,
        fontWeight: "400",
    };

    const yesCellStyle = {
        ...cellStyle,
    };

    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };



    //! ----------------------------------------------------------

    const renderTextAreaFull = (fieldName, placeholder, formData = '', rowCount = 2) => (
        <InputTextarea
            placeholder={placeholder}
            name={fieldName}
            autoResize
            rows={rowCount}
            id={fieldName}
            value={formData}
            // value={formData !== '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value);
            }}

            style={{
                width: '100%',
                textAlign: 'center',
                fontSize: '14px',
                backgroundColor: '#f1f3f5',
                border: '1px solid #ced4da',
                color: '#212529'
            }}
        ></InputTextarea>
    );


    const renderInputAreaForAmount = (fieldName, formData = '', disabled = false) => (
        <InputNumber
            inputId="currency-us"
            className="text-center"
            inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
            value={formData !== '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.value);
            }}
            disabled={disabled}
            mode="currency"
            currency="USD"
            locale="en-US"
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                }
            }}
            style={{
                width: "100%",
                height: "40px",
                boxSizing: "border-box",
                border: "none",
                fontSize: "16px",
                textAlign: "center !important",
                marginTop: "0px",
            }}
        />
    );

    const renderInputAreaForPercentage = (fieldName, formData = '', disabled = false) => (
        <InputNumber
            inputId="percentage"
            className="text-center"
            inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
            value={formData !== '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.value);
            }}
            disabled={disabled}
            mode="decimal" // Use "decimal" for percentage formatting
            locale="en-US"
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                }
            }}
            suffix="%" // Append '%' to the value
            style={{
                width: "100%",
                height: "40px",
                boxSizing: "border-box",
                border: "none",
                fontSize: "16px",
                textAlign: "center", // Remove the "!important" which is invalid in inline styles
                marginTop: "0px",
            }}
        />
    );

    const renderInputArea = (fieldName, placeholder = '', type = 'text', formData = '') => (
        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formData !== '' ? formData : formik.values[fieldName]}
            step="any"
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value);

            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                }
            }}
            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', fontSize: '16px', textAlign: 'center', marginTop: '0px' }}
        />
    );

    const renderSelect = (fieldName, formdata = '') => {
        const value = formdata !== '' ? formdata : formik.values[fieldName] || '';

        const backgroundColor = value === 'off-track'
            ? '#6c757d'   // gray
            : value === 'on-track'
                ? '#0d6efd' // blue
                : value === 'complete'
                    ? '#28a745' // green
                    : '#ffffff'; // default

        const textColor = value ? '#ffffff' : '#000000';

        return (
            <select
                name={fieldName}
                id={fieldName}
                value={value}
                onChange={(e) => formik.setFieldValue(fieldName, e.target.value)}
                style={{
                    width: '100%',
                    textAlign: 'center',
                    fontSize: '16px',
                    backgroundColor: backgroundColor,
                    color: textColor,
                    border: '1px solid #ced4da',
                    borderRadius: '4px'
                }}
            >
                <option value="">Select</option>
                <option value="off-track">Off Track</option>
                <option value="on-track">On Track</option>
                <option value="complete">Complete</option>
            </select>
        );
    };

    // const renderSelect = (fieldName, formdata = '', nextMeetingText = '', isProject = true) => {
    //     const value = formdata !== '' ? formdata : formik.values[fieldName] || '';

    //     const backgroundColor = value === 'off-track'
    //         ? '#6c757d'   // gray
    //         : value === 'on-track'
    //             ? '#0d6efd' // blue
    //             : value === 'complete'
    //                 ? '#28a745' // green
    //                 : '#ffffff'; // default

    //     const textColor = value ? '#ffffff' : '#000000';

    //     const handleStatusChange = (e) => {
    //         const newStatus = e.target.value;
    //         formik.setFieldValue(fieldName, newStatus);

    //         // If status is complete and we have next meeting text
    //         if (newStatus === 'complete' && nextMeetingText) {
    //             if (isProject) {
    //                 // Add to project completed tasks
    //                 const updatedTasks = [...formik.values.complate_task_project, {
    //                     task: nextMeetingText,
    //                     date: new Date().toISOString().split('T')[0]
    //                 }];
    //                 formik.setFieldValue('complate_task_project', updatedTasks);
    //                 setcomplate_task_project(updatedTasks);
    //             }
    //         }
    //     };

    //     return (
    //         <select
    //             name={fieldName}
    //             id={fieldName}
    //             value={value}
    //             onChange={handleStatusChange}
    //             style={{
    //                 width: '100%',
    //                 textAlign: 'center',
    //                 fontSize: '16px',
    //                 color: textColor,
    //                 backgroundColor: backgroundColor,
    //                 border: 'none',
    //                 height: '40px'
    //             }}
    //         >
    //             <option value="">Select Status</option>
    //             <option value="off-track">Not Done</option>
    //             <option value="complete">Done</option>
    //         </select>
    //     );
    // };    

    const renderSelect2 = (fieldName, formdata = '') => {
        const value = formdata !== '' ? formdata : formik.values[fieldName] || '';

        const backgroundColor = value === 'done'
            ? '#28a745'
            : value === 'not-done'
                ? '#fd7e14'
                : '#ffffff';

        const textColor = value ? '#ffffff' : '#000000';

        const handleChange = (e) => {
            const newValue = e.target.value;
            formik.setFieldValue(fieldName, newValue);

            // ✅ Append to COMPLETED TASKS - PROJECTS if done
            if (newValue === 'done') {
                const taskDescription = `Task marked as done: ${fieldName}`;

                console.log(taskDescription);
                // Avoid duplicate entries
                const alreadyExists = formik.values.complate_task_project.some(
                    (item) => item.description === taskDescription
                );

                if (!alreadyExists) {
                    const updatedTasks = [
                        ...formik.values.complate_task_project,
                        { description: taskDescription }
                    ];
                    formik.setFieldValue('complate_task_project', updatedTasks);
                }
            }
        };

        return (
            <select
                name={fieldName}
                id={fieldName}
                value={value}
                onChange={handleChange}
                style={{
                    width: '100%',
                    textAlign: 'center',
                    fontSize: '16px',
                    backgroundColor,
                    color: textColor,
                    border: '1px solid #ced4da',
                    borderRadius: '4px'
                }}
            >
                <option value="">Select</option>
                <option value="done">Done</option>
                <option value="not-done">Not Done</option>
            </select>
        );
    };


    // ----------------------------------------------------------------------------

    const toast = useRef(null);

    const formik = useFormik({
        initialValues: EsrDashboardTemp.getFormName(),
        enableReinitialize: true,
        validate: (data) => {

        },

        onSubmit: (data) => {
            console.log("data");
            console.log(data);

            data.user_id = localStorage.getItem('user_id');
            data.role_id = localStorage.getItem('role_id');

            var url = Api.API_BASE_URL + 'esr/save';

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                ...Api.headers,
                'Authorization': token ? `Bearer ${token}` : ''
            };


            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    });

    return (
        <>
            <Toast ref={toast} />

            <form onSubmit={formik.handleSubmit} className='pm-template-form'>
                <div className='flex d-flex justify-content-between top-button '>
                    {/* <div className='p-2' >
                        <Dropdown
                            value={formik.values.quarter}
                            options={[
                                { label: 'Q1', value: 'Q1' },
                                { label: 'Q2', value: 'Q2' },
                                { label: 'Q3', value: 'Q3' },
                                { label: 'Q4', value: 'Q4' }
                            ]}
                            optionValue='value'
                            onChange={(e) => {
                                console.log(e.value)
                                formik.setFieldValue('quarter', e.value);
                                setQuarter(e.value);
                            }}
                            placeholder="Select a Quater"
                            style={{ width: '150px' }}
                        />
                    </div> */}

                    <div className="p-2 flex gap-2 quarter-tabs">
                        {['Q1', 'Q2', 'Q3', 'Q4'].map((q) => (
                            <button
                                key={q}
                                type="button"
                                className={`quarter-tab-button ${formik.values.quarter === q ? 'active' : ''}`}
                                onClick={() => {
                                    formik.setFieldValue('quarter', q);
                                    setQuarter(q);
                                }}
                            >
                                {q}
                            </button>
                        ))}
                    </div>

                    <h2 className="esr-page-title text-center">
                        {formik.values.quarter} EXECUTIVE SUMMARY REPORT (ESR) 2025
                    </h2>
                    {/* <div className="p-2 flex gap-2 quarter-tabs">
                        ...
                    </div> */}

                    <button type="submit" title='Save' style={{ cursor: 'pointer' }} className="customSave-button m-2" >
                        <div className='flex gap-2 px-1 ' style={{ alignItems: 'center' }}>
                            <FaSave size={16} />
                            <span> SAVE </span>
                        </div>
                    </button>
                </div>

                <div className="estimating-card" style={{ margin: 0, border: 'none', }}>

                    <div className="section-block">

                        <h4 className="section-title">FORWARD GUIDANCE</h4>
                        <div className="table-container" style={{ overflowX: "auto" }}>

                            <table style={{ borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...headerStyle, width: "300px", }}>
                                            KEY METRICS
                                        </th>
                                        <th style={{ ...headerStyle, minWidth: "100px", }}>
                                            GOAL
                                        </th>

                                        <th style={{ ...headerStyle, }}>
                                            FORECAST
                                        </th>

                                        <th style={{ ...headerStyle, width: "150px", }}>
                                            STATUS
                                        </th>

                                        <th style={{ ...headerStyle, width: "330px" }}>
                                            COMMENTS
                                        </th>
                                        {/* <th style={{ ...headerStyle, width: "100px", }}>
                                            (+/-)
                                        </th> */}

                                    </tr>

                                </thead>

                                <tbody>
                                    <tr >
                                        {/* <td style={{ height: "40px", }} colSpan={2}>
                                            Financials
                                        </td> */}
                                        <td className="table-section-header" style={{ height: "40px" }}>
                                            Financials
                                        </td>
                                    </tr>

                                    {financials.map((item, index) => (
                                        <tr >
                                            {/* <td style={cellStyleW}>
                                                {renderTextAreaFull(`Financials.${index}.key_matrics`, "", formik.values.Financials[index].key_matrics)}
                                            </td> */}

                                            <td style={{ ...cellStyleW, textAlign: 'center' }}>
                                                {[
                                                    "Annual Revenue",
                                                    "Annual Gross Profit",
                                                    "Annual Fixed Expense",
                                                    "Annual Net Profit",                                                    
                                                    "Q1 Revenue",
                                                    "Q1 Gross Profit",
                                                    "Q1 Fixed Expense",
                                                    "Q1 Net Profit"
                                                ][index]}
                                            </td>


                                            <td style={cellStyleW} >
                                                <div className='flex'>
                                                    <div style={{ width: '60%', borderRight: '1px solid black' }}>
                                                        {renderInputAreaForAmount(`Financials.${index}.goal`, formik.values.Financials[index].goal)}
                                                    </div>
                                                    <div style={{ width: '40%' }}>
                                                        {renderInputAreaForPercentage(`Financials.${index}.goal_per`, formik.values.Financials[index].goal_per)}
                                                    </div>
                                                </div>
                                            </td>

                                            <td style={cellStyleW} >
                                                <div className='flex'>
                                                    <div style={{ width: '60%', borderRight: '1px solid black'}}>
                                                        {renderInputAreaForAmount(`Financials.${index}.forecast`, formik.values.Financials[index].forecast, true)}
                                                    </div>
                                                    <div style={{ width: '40%' }}>
                                                        {renderInputAreaForPercentage(`Financials.${index}.forecast_per`, formik.values.Financials[index].forecast_per, true)}
                                                    </div>
                                                </div>
                                            </td>

                                            <td style={{ ...dropdownCellStyle, height: '32px', }}>
                                                {renderSelect(`Financials.${index}.status`, formik.values.Financials[index].status)}
                                            </td>

                                            <td style={cellStyleW}>
                                                {renderTextAreaFull(`Financials.${index}.comment`, '', formik.values.Financials[index].comment)}
                                                {/* {renderTextAreaFull(`Financials.${index}.comment`, '')} */}
                                            </td>

                                            {/* <td style={cellStyle}>
                                                {index > 5 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForFinancials(index)} />) : null}
                                                {financials.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForFinancials()} />) : null}
                                            </td> */}

                                        </tr>
                                    ))}

                                    <tr >
                                        {/* <td style={{ height: "40px", }} colSpan={2}>
                                            Sales
                                        </td> */}
                                        <td className="table-section-header" style={{ height: "40px" }}>
                                            Sales
                                        </td>
                                    </tr>
                                    {Sales.map((item, index) => (
                                        <tr>


                                            {/* <td style={cellStyleW}>
                                                {renderTextAreaFull(`Sales.${index}.key_matrics`, "", formik.values.Sales[index].key_matrics)}
                                            </td> */}

                                            <td style={{ ...cellStyleW, textAlign: 'center' }}>
                                                {[
                                                    "Annual Sales",
                                                    "Q1 Sales (Pre-Con)",
                                                    "Q1 Sales (Construction)"
                                                ][index]}
                                            </td>

                                            <td style={cellStyleW}>
                                                <div className='flex'>
                                                    {renderInputAreaForAmount(`Sales.${index}.goal`, formik.values.Sales[index].goal)}

                                                </div>

                                            </td>

                                            <td style={cellStyleW}>
                                                <div className='flex'>
                                                    {renderInputAreaForAmount(`Sales.${index}.forecast`, formik.values.Sales[index].forecast)}

                                                </div>

                                            </td>

                                            <td style={{ ...dropdownCellStyle, height: '32px', }}>
                                                {renderSelect(`Sales.${index}.status`, formik.values.Sales[index].status)}
                                            </td>


                                            <td style={cellStyleW}>
                                                {renderTextAreaFull(`Sales.${index}.comment`, '', formik.values.Sales[index].comment)}
                                            </td>

                                            {/* <td style={cellStyle}>
                                                {index > 2 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSales(index)} />) : null}
                                                {Sales.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSales()} />) : null}
                                            </td> */}

                                        </tr>
                                    ))}

                                    <tr style={{ marginTop: '20px' }}>
                                        {/* <td style={{ height: "40px", }} colSpan={2}>
                                            Critical Dates
                                        </td> */}
                                        <td className="table-section-header" style={{ height: "40px" }}>
                                            Critical Dates
                                        </td>

                                    </tr>

                                    {Critical_Dates.map((item, index) => (
                                        <tr>

                                            <td style={{ ...cellStyleW, textAlign: 'center' }}>
                                                {[
                                                    "Break-Even Cash Flow",
                                                    "Zero Revenue"
                                                ][index]}
                                            </td>

                                            {/* <td style={cellStyleW}>
                                                {renderTextAreaFull(`Critical_Dates.${index}.key_matrics`, "", formik.values.Critical_Dates[index].key_matrics)}
                                            </td> */}

                                            <td style={cellStyleW}>
                                                {/* <div className='flex'>
                                                    {renderInputArea(`Critical_Dates.${index}.goal`, '', 'date', formik.values.Critical_Dates[index].goal)}

                                                </div> */}
                                                <div className='flex'>
                                                    {renderInputAreaForAmount(`Critical_Dates.${index}.goal`, formik.values.Critical_Dates[index].goal)}
                                                </div>                                                

                                            </td>

                                            <td style={cellStyleW}>
                                                <div className='flex'>

                                                    {renderInputArea(`Critical_Dates.${index}.forecast`, '', 'date', formik.values.Critical_Dates[index].forecast)}

                                                </div>

                                            </td>

                                            <td style={{ ...dropdownCellStyle, height: '32px', }}>
                                                {renderSelect(`Critical_Dates.${index}.status`, formik.values.Critical_Dates[index].status)}
                                            </td>


                                            <td style={cellStyleW}>
                                                {renderTextAreaFull(`Critical_Dates.${index}.comment`, '', formik.values.Critical_Dates[index].comment)}
                                            </td>

                                            {/* <td style={cellStyle}>
                                                {index > 1 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForCritical_Dates(index)} />) : null}
                                                {Critical_Dates.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForCritical_Dates()} />) : null}
                                            </td> */}

                                        </tr>
                                    ))}

                                </tbody>
                            </table>

                        </div>
                    </div>

                    <h4 className="section-title">STRATEGIC INITIATIVES</h4>
                    <div className="table-container" style={{ overflowX: "auto" }}>
                        <table style={{ borderCollapse: "collapse", }}>
                            <thead>


                                <tr>
                                    <th style={{ ...headerStyle, width: "300px", }}>
                                        STRATEGIC INITIATIVES
                                    </th>

                                    <th style={{ ...headerStyle, minWidth: "auto", }}>
                                        DESCRIPTION
                                    </th>

                                    <th style={{ ...headerStyle, width: "150px", }}>
                                        STATUS
                                    </th>

                                    <th style={{ ...headerStyle, width: "330px", }}>
                                        COMMENTS
                                    </th>

                                    {/* <th style={{ ...headerStyle, width: "100px", }}>
                                        (+/-)
                                    </th> */}
                                </tr>

                            </thead>

                            <tbody>
                                <tr style={{ marginTop: '20px' }}>
                                    {/* <td style={{ height: "40px", }} colSpan={2}>
                                        Projects
                                    </td> */}
                                    <td className="table-section-header" style={{ height: "40px" }}>
                                        Projects
                                    </td>
                                </tr>

                                {SI_Project.map((item, index) => (

                                    <tr>
                                        <td style={{ ...cellStyleW, textAlign: 'center' }}>
                                            {[
                                                "Next Meeting",
                                                "Q1",
                                                "Annual "
                                            ][index]}
                                        </td>

                                        {/* <td style={cellStyleW} >
                                            {renderTextAreaFull(`SI_Project.${index}.title`, "", formik.values.SI_Project[index].title)}
                                        </td> */}

                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`SI_Project.${index}.description`, "", formik.values.SI_Project[index].description)}
                                        </td>


                                        <td style={{ ...dropdownCellStyle, height: '32px', }}>
                                            {index == 0 ? renderSelect2(`SI_Project.${index}.status`, formik.values.SI_Project[index].status) : renderSelect(`SI_Project.${index}.status`, formik.values.SI_Project[index].status)}
                                        </td>


                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`SI_Project.${index}.comments`, '', formik.values.SI_Project[index].comments)}
                                        </td>

                                        {/* <td style={cellStyle}>
                                            {index > 2 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSI_Project(index)} />) : null}
                                            {SI_Project.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSI_Project()} />) : null}
                                        </td> */}



                                    </tr>

                                ))}

                                <tr style={{ marginTop: '20px' }}>
                                    {/* <td style={{ height: "40px", }} colSpan={2}>
                                        Personel
                                    </td> */}
                                    <td className="table-section-header" style={{ height: "40px" }}>
                                        Personel
                                    </td>
                                </tr>

                                {SI_Personal.map((item, index) => (
                                    <tr>
                                        <td style={{ ...cellStyleW, textAlign: 'center' }}>
                                            {[
                                                "Next Meeting",
                                                "Q1",
                                                "Annual "
                                            ][index]}
                                        </td>

                                        {/* <td style={cellStyleW} >
                                            {renderTextAreaFull(`SI_Personal.${index}.title`, "", formik.values.SI_Personal[index].title)}
                                        </td> */}

                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`SI_Personal.${index}.description`, "", formik.values.SI_Personal[index].description)}
                                        </td>


                                        <td style={{ ...dropdownCellStyle, height: '32px', }}>
                                            {index == 0 ? renderSelect2(`SI_Personal.${index}.status`, formik.values.SI_Personal[index].status) : renderSelect(`SI_Personal.${index}.status`, formik.values.SI_Personal[index].status)}
                                        </td>


                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`SI_Personal.${index}.comments`, '', formik.values.SI_Personal[index].comments)}
                                        </td>

                                        {/* <td style={cellStyle}>
                                            {index > 2 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSI_Personal(index)} />) : null}
                                            {SI_Personal.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSI_Personal()} />) : null}
                                        </td> */}
                                    </tr>


                                ))}
                            </tbody>
                        </table>
                    </div>


                    <h4 className="section-title">ISSUES LIST</h4>
                    <div className="table-container" style={{ overflowX: "auto" }}>
                        <table style={{ borderCollapse: "collapse", }}>
                            <thead>

                                <tr>
                                    <th style={{ ...headerStyle, width: "300px", }}>
                                        ISSUES LIST
                                    </th>
                                    <th style={{ ...headerStyle, minWidth: "auto", }}>
                                        DESCRIPTION & DATE STAMP
                                    </th>
                                    <th style={{ ...headerStyle, width: "150px", }}>
                                        STATUS{/* Long Term Issues (ie. Will be addressed in more than 4 weeks)  */}
                                    </th>
                                    <th style={{ ...headerStyle, width: "330px", }}>
                                        DESCRIPTION & DATE STAMP
                                    </th>
                                    {/* <th style={{ ...headerStyle, width: "100px", }}>
                                        (+/-)
                                    </th> */}
                                </tr>

                            </thead>

                            <tbody>
                                <tr style={{ marginTop: '20px' }}>
                                    {/* <td style={{ height: "40px", }} colSpan={2}>
                                        Projects
                                    </td> */}
                                    <td className="table-section-header" style={{ height: "40px" }}>
                                        Projects
                                    </td>
                                </tr>
                                {issue_list_project.map((item, index) => (
                                    <tr>

                                        <td style={{ ...cellStyleW, textAlign: 'center' }}>
                                            {[
                                                "Next Meeting",
                                                "Q1",
                                                "Annual "
                                            ][index]}
                                        </td>

                                        {/* <td style={cellStyleW}>
                                            {renderTextAreaFull(`issue_list_project.${index}.short_terms_issue_1`, "", formik.values.issue_list_project[index].short_terms_issue_1)}
                                        </td> */}

                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`issue_list_project.${index}.description_and_datetime_1`, "", formik.values.issue_list_project[index].description_and_datetime_1)}
                                        </td>


                                        <td style={{ ...dropdownCellStyle, height: '32px', }}>
                                            {renderSelect2(`issue_list_project.${index}.short_terms_issue_2`, formik.values.issue_list_project[index].short_terms_issue_2)}
                                        </td>


                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`issue_list_project.${index}.description_and_datetime_2`, '', formik.values.issue_list_project[index].description_and_datetime_2)}
                                        </td>

                                        {/* <td style={cellStyle}>
                                            {index > 2 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForissue_list_project(index)} />) : null}
                                            {issue_list_project.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForissue_list_project()} />) : null}
                                        </td> */}

                                    </tr>

                                    
                                ))}
                                <tr style={{ marginTop: '20px' }}>
                                    {/* <td style={{ height: "40px", }} colSpan={2}>
                                        Personnel
                                    </td> */}
                                    <td className="table-section-header" style={{ height: "40px" }}>
                                        Personnel
                                    </td>

                                </tr>
                                {issue_list_personal.map((item, index) => (
                                    <tr>

                                        <td style={{ ...cellStyleW, textAlign: 'center' }}>
                                            {[
                                                "Next Meeting",
                                                "Q1",
                                                "Annual "
                                            ][index]}
                                        </td>

                                        {/* <td style={cellStyleW}>
                                            {renderTextAreaFull(`issue_list_personal.${index}.short_terms_issue_1`, "", formik.values.issue_list_personal[index].short_terms_issue_1)}
                                        </td> */}

                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`issue_list_personal.${index}.description_and_datetime_1`, "", formik.values.issue_list_personal[index].description_and_datetime_1)}
                                        </td>


                                        <td style={{ ...dropdownCellStyle, height: '32px', }}>
                                            {renderSelect2(`issue_list_personal.${index}.short_terms_issue_2`, formik.values.issue_list_personal[index].short_terms_issue_2)}
                                        </td>


                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`issue_list_personal.${index}.description_and_datetime_2`, '', formik.values.issue_list_personal[index].description_and_datetime_2)}
                                        </td>

                                        {/* <td style={cellStyle}>
                                            {index > 2 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForissue_list_personal(index)} />) : null}
                                            {issue_list_personal.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForissue_list_personal()} />) : null}
                                        </td> */}

                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>


                    <h4 className="section-title">PRE CONSTRUCTION SCHEDULED MILESTONES</h4>
                    <div className="table-container" style={{ overflowX: "auto" }}>
                        <table style={{ borderCollapse: "collapse", }}>
                            <thead>

                                <tr>
                                    <th style={{ ...headerStyle, minWidth: "auto", }}>
                                        COMPLETED TASKS - PROJECTS
                                    </th>
                                    <th style={{ ...headerStyle, width: "100px", }}>
                                        (+/-)
                                    </th>
                                </tr>

                            </thead>

                            <tbody>
                                {complate_task_project.map((item, index) => (
                                    <tr>
                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`complate_task_project.${index}.description`, '', formik.values.complate_task_project[index].description)}
                                        </td>

                                        <td style={cellStyle}>
                                            {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForcomplate_task_project(index)} />) : null}
                                            {complate_task_project.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForcomplate_task_project()} />) : null}
                                        </td>

                                    </tr>
                                ))}


                            </tbody>
                        </table>
                    </div>


                    <h4 className="section-title">PRE CONSTRUCTION SCHEDULED MILESTONES</h4>
                    <div className="table-container" style={{ overflowX: "auto" }}>
                        <table style={{ borderCollapse: "collapse", }}>
                            <thead>

                                <tr>
                                    <th style={{ ...headerStyle, minWidth: "auto", }}>
                                        COMPLETED TASKS - PERSONAL
                                    </th>
                                    <th style={{ ...headerStyle, width: "100px", }}>
                                        (+/-)
                                    </th>
                                </tr>

                            </thead>

                            <tbody>
                                {complate_task_personal.map((item, index) => (
                                    <tr>
                                        <td style={cellStyleW}>
                                            {renderTextAreaFull(`complate_task_personal.${index}.description`, '', formik.values.complate_task_personal[index].description)}
                                        </td>

                                        <td style={cellStyle}>
                                            {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForcomplate_task_personal(index)} />) : null}
                                            {complate_task_personal.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForcomplate_task_personal()} />) : null}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </form>
        </>
    )
}

export default EsrDashboard